var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-overlay',{attrs:{"opacity":0.5}},[_c('span',[_vm._v(" "+_vm._s(_vm.$tc("dashboard.loading"))+" ")]),_c('v-progress-linear',{attrs:{"buffer-value":"0","stream":"","color":"#45D6E5"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }